import type { Mission } from '../missions.ts'

export const nist: Mission = {
  id: "nist",
  name: "National Institute of Standards and Technology",
  short: "NIST",
  call: "Standards",
  kind: "subagency",
  parent: "doc",
  url: "https://www.nist.gov/",
  established: 1901,
  palette: {
    primary: "#005ea2",
    secondary: "#1b1b1b",
    accent: "#f6ca43",
  },
  colorSource: {
    kind: "site",
    url: "https://www.nist.gov/",
  },
  motif: "atom",
  mission: {
    text: "To promote U.S. innovation and industrial competitiveness by advancing measurement science, standards, and technology in ways that enhance economic security and improve our quality of life.",
    url: "https://www.nist.gov/about-nist",
  },
  fact: {
    text: "NIST, founded in 1901, is one of the nation's oldest physical science laboratories.",
    url: "https://www.nist.gov/history",
  },
  logo: {
    file: "public/logos/nist.svg",
    source: "https://commons.wikimedia.org/wiki/File:NIST_logo.svg",
  },
  identifier: {
    about: "https://www.nist.gov/about-nist",
    accessibility: "https://www.nist.gov/oism/accessibility",
    foia: "https://www.nist.gov/office-director/freedom-information-act",
    noFear: "https://www.nist.gov/no-fear-act-policy",
    oig: "https://www.oig.doc.gov/",
    performance: "https://www.nist.gov/about-nist/budget-planning",
    privacy: "https://www.nist.gov/privacy-policy",
  },
  media: {
    photos: [
      {
        file: "/media/nist-newton-apple-tree.jpg",
        small: "/media/nist-newton-apple-tree-sm.jpg",
        alt: "Sunlight through the spreading branches of the Newton apple tree on NIST's Gaithersburg campus on a spring morning.",
        title: "Newton apple tree, NIST Gaithersburg",
        creator: "National Institute of Standards and Technology",
        source: "https://commons.wikimedia.org/wiki/File:NIST_Gaithersburg_Newton_Apple_Tree_Dsc_9822-hdr-edit_processed_16x9_web.jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/nist-ytterbium-clock.jpg",
        small: "/media/nist-ytterbium-clock-sm.jpg",
        alt: "A dense laboratory table of lasers, optics, cables and a vacuum chamber that make up NIST's ytterbium lattice atomic clock.",
        title: "Ytterbium lattice atomic clock, NIST",
        creator: "National Institute of Standards and Technology",
        source: "https://commons.wikimedia.org/wiki/File:Ytterbium_Lattice_Atomic_Clock_(10444764266).jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
